/**
 * ICSC Professional Competency Accreditation Framework (PCAF) API Service
 *
 * All API calls for professional competency courses, enrollments, assessments, exams, and certificates
 */
import axios from '../api/axiosClient';

// ============================================================================
// COURSES & FRAMEWORKS
// ============================================================================

export const getAllCourses = async (status = null) => {
  const params = status ? { status } : {};
  const response = await axios.get('/professional-competency/courses', { params });
  return response.data;
};

export const getCourseDetail = async (courseId) => {
  const response = await axios.get(`/professional-competency/courses/${courseId}`);
  return response.data;
};

export const getAllFrameworks = async () => {
  const response = await axios.get('/professional-competency/frameworks');
  return response.data;
};

export const getFramework = async (competencyType) => {
  const response = await axios.get(`/professional-competency/frameworks/${competencyType}`);
  return response.data;
};

// ============================================================================
// ENROLLMENTS
// ============================================================================

export const enrollLearner = async (enrollmentData) => {
  const response = await axios.post('/professional-competency/enrol', enrollmentData);
  return response.data;
};

export const getMyEnrollments = async () => {
  const response = await axios.get('/professional-competency/enrollments/my');
  return response.data;
};

export const updateProgress = async (enrollmentId, completedModuleId) => {
  const response = await axios.post(
    `/professional-competency/enrollments/${enrollmentId}/progress`,
    null,
    { params: { completed_module_id: completedModuleId } }
  );
  return response.data;
};

export const getProgress = async (enrollmentId) => {
  const response = await axios.get(`/professional-competency/enrollments/${enrollmentId}/progress`);
  return response.data;
};

// ============================================================================
// ASSESSMENTS
// ============================================================================

export const submitAssessment = async (assessmentData) => {
  const response = await axios.post('/professional-competency/assessments/submit', assessmentData);
  return response.data;
};

export const reviewAssessment = async (assessmentId, reviewData) => {
  const response = await axios.post(`/professional-competency/assessments/${assessmentId}/review`, reviewData);
  return response.data;
};

// ============================================================================
// EXAMS
// ============================================================================

export const startExam = async (enrollmentId) => {
  const response = await axios.post('/professional-competency/exams/start', { enrollment_id: enrollmentId });
  return response.data;
};

export const submitExam = async (examId, answers) => {
  const response = await axios.post('/professional-competency/exams/submit', { exam_id: examId, answers });
  return response.data;
};

export const getExamResults = async (examId) => {
  const response = await axios.get(`/professional-competency/exams/${examId}/results`);
  return response.data;
};

// ============================================================================
// EVIDENCE
// ============================================================================

export const submitEvidence = async (evidenceData) => {
  const response = await axios.post('/professional-competency/evidence/submit', evidenceData);
  return response.data;
};

export const reviewEvidence = async (evidenceId, reviewData) => {
  const response = await axios.post(`/professional-competency/evidence/${evidenceId}/review`, reviewData);
  return response.data;
};

// ============================================================================
// ACCREDITATION
// ============================================================================

export const submitForAccreditation = async (enrollmentId) => {
  const response = await axios.post(`/professional-competency/accreditation/submit`, null, {
    params: { enrollment_id: enrollmentId }
  });
  return response.data;
};

export const makeAccreditationDecision = async (accreditationId, decisionData) => {
  const response = await axios.post(
    `/professional-competency/accreditation/${accreditationId}/decision`,
    decisionData
  );
  return response.data;
};

export const getUserAccreditations = async (userId) => {
  const response = await axios.get(`/professional-competency/accreditation/${userId}`);
  return response.data;
};

// ============================================================================
// CERTIFICATES
// ============================================================================

export const issueCertificate = async (certificateData) => {
  const response = await axios.post('/professional-competency/certificates/issue', certificateData);
  return response.data;
};

export const getCertificate = async (certificateId) => {
  const response = await axios.get(`/professional-competency/certificates/${certificateId}`);
  return response.data;
};

export const verifyCertificate = async (certificateNumber) => {
  const response = await axios.get(`/professional-competency/certificates/verify/${certificateNumber}`);
  return response.data;
};

// ============================================================================
// DASHBOARD
// ============================================================================

export const getDashboardStats = async () => {
  const response = await axios.get('/professional-competency/dashboard/stats');
  return response.data;
};
